import React from 'react'

const NotYetCertifiedCard = () => {
    return (
        <div style={{ border: '2px solid #131313', borderRadius: '0.75rem', padding: '2px 8px', backgroundColor: '#FEFEFE', width: '70px' }}>
            <div className='df aic jcc mt0-25rem'>
                <img
                    src={require('../../../../../../images/checklist-logo.webp')}
                    style={{
                        width: "20px",
                        height: "17px"
                    }}
                    alt="none"
                />
            </div>
            <h3 className='w100 tac fs9px my0-5rem' style={{ lineHeight: '1.2', color: '#2D2D2D' }}>Not Yet <br></br> Certified</h3>
            <p className='w100 tac mb0-25rem' style={{ color: '#1C1A1AB2', fontSize: '7px' }}>Unaudited</p>
        </div>
    )
}

export default NotYetCertifiedCard